import { UserService } from "@/services";
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
export default {
  name: "wallet-setting",
  components: {},
  props: [],
  data() {
    return {
      walletSettingDialog: false,
      assetsTypeValue: "",
      nameTypeValue: ""
    };
  },
  computed: {
    ...mapGetters({
      wallets: types.wallets.getters.GET_NEW_WALLETS,
      userSetting: types.userSetting.getters.GET_USER_SETTING
    })
  },
  mounted() {
    this.assetsTypeValue = this.userSetting.wallet.setting.assets_currency_type;
    this.nameTypeValue = this.userSetting.wallet.setting.display_currency_type;
  },
  methods: {
    ...mapActions({
      setUserSetting: types.userSetting.actions.SET_USER_SETTING
    }),
    addClassForWalletSettingRadio(index) {
      if (!this.$vuetify.breakpoint.smAndDown) {
        if (this.$vuetify.rtl) {
          return index % 2 === 0
            ? "gateway-padding-left"
            : "gateway-padding-right";
        } else {
          return index % 2 === 0
            ? "gateway-padding-right"
            : "gateway-padding-left";
        }
      } else {
        if (this.$vuetify.rtl) {
          return index % 2 === 0 ? "pe-3" : "ps-3";
        } else {
          return index % 2 === 0 ? "ps-3" : "pe-3";
        }
      }
    },
    setAssetsCurrencyType(value) {
      const data = this.userSetting;
      data.wallet.setting.assets_currency_type = value;
      UserService.setSetting(data).then(res => {
        this.setUserSetting(res.data.data);
      });
    },
    setDisplayCurrencyType(value) {
      const data = this.userSetting;
      data.wallet.setting.display_currency_type = value;
      UserService.setSetting(data).then(res => {
        this.setUserSetting(res.data.data);
      });
    }
  }
};
